import { h, Component } from 'preact'; /** @jsx h */
import mitt from 'mitt';
import root from '@components/root';

const localStorageSupport = 'localStorage' in root;

const ignoreSave = ['hasTranslationRoute'];

/** Instantiates a pubsub and exposes it via context */
export class PubSub {
  events = mitt();
  get = key => {
    if (localStorageSupport) {
      const val = localStorage.getItem(`TableOnline--${key}`);
      return !val
        ? null
        : val.indexOf('{') === 0 || val.indexOf('[') === 0
        ? JSON.parse(val)
        : val;
    }
    return null;
  };
  getChildContext() {
    return {
      events: {
        ...this.events,
        get: this.get,
        emit: (type, data) => updateData(this.events.emit, type, data),
      },
    };
  }
  render({ children }) {
    return children[0];
  }
}

/** Passes pubsub's emit() function as a prop (avoids direct context access) */
const connect = Component => (props, context) =>
  (
    <Component
      emit={(type, data) => updateData(context.events.emit, type, data)}
      {...props}
    />
  );

const updateLocalStorage = (type, data) => {
  if (localStorageSupport && !ignoreSave.includes(type))
    data === null || data === void 0
      ? root.localStorage.removeItem(`TableOnline--${type}`)
      : root.localStorage.setItem(
          `TableOnline--${type}`,
          typeof data === 'string' ? data : JSON.stringify(data)
        );
};

const updateData = (emit, type, data) => {
  lastState[type] = data;
  emit(type, data);
  updateLocalStorage(type, data);
};

/** Emits a pubsub event when rendered */

export const Emit = connect(({ emit, ...props }) =>
  Object.keys(props).forEach(type => {
    if (type === 'children') return;
    updateData(emit, type, props[type]);
  })
);

let lastState = localStorageSupport
  ? Object.keys(localStorage).reduce((obj, str) => {
      if (str.indexOf('TableOnline--') === 0) {
        const item = localStorage.getItem(str);
        obj[str.slice(13)] =
          item.indexOf('{') === 0 || item.indexOf('[') === 0
            ? JSON.parse(item)
            : item;
      }
      return obj;
    }, {})
  : {};

/** Binds listener props to pubsub */
export class Stateful extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.props.events.forEach(key => {
      this.state[key] = lastState[key];
    });
  }
  onUpdate = key => {
    return data => {
      if (this.state[key] !== data) {
        this.setState({ [key]: data });
        lastState[key] = data;
        updateLocalStorage(key, data);
      }
    };
  };
  componentDidMount() {
    this.bind('on', this.props.events);
  }
  componentDidUpdate(oldProps) {
    this.bind('off', oldProps.events);
    this.bind('on', this.props.events);
  }
  componentWillUnmount() {
    this.bind('off', this.props.events);
  }
  bind(method, events = []) {
    events.forEach(key => this.context.events[method](key, this.onUpdate(key)));
  }
  render({ children }, state) {
    return typeof children[0] === 'function' ? children[0](state) : null;
  }
}

/** Binds listener props to pubsub */
export class Observe extends Component {
  componentDidMount() {
    this.bind('on', this.props);
  }
  componentDidUpdate(oldProps) {
    this.bind('off', oldProps);
    this.bind('on', this.props);
  }
  componentWillUnmount() {
    this.bind('off', this.props);
  }
  bind(method, events) {
    for (let i in events)
      if (typeof events[i] === 'function') {
        this.context.events[method](
          i.replace(/^on/, '').toLowerCase(),
          events[i]
        );
      }
  }
}



// WEBPACK FOOTER //
// ./components/pubsub/index.js